import {useEffect, useRef} from 'react';
import {IconButton, Stack, TextField, Typography} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface TinyRowSearchProps {
    open: boolean;
    query: string;
    matchCount: number | null;
    onToggle: () => void;
    onQueryChange: (value: string) => void;
}

/** 科目标题旁的搜索开关。展开后过滤当前 Tiny 标签，Esc 收起并清空。 */
export default function TinyRowSearch({
    open,
    query,
    matchCount,
    onToggle,
    onQueryChange,
}: TinyRowSearchProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (open) inputRef.current?.focus();
    }, [open]);

    return (
        <Stack direction="row" alignItems="center" spacing={0.75} sx={{minWidth: 0}}>
            <IconButton
                size="small"
                color={open ? 'primary' : 'default'}
                onClick={onToggle}
                aria-label={open ? 'Close search' : 'Search'}
            >
                <SearchIcon fontSize="small"/>
            </IconButton>
            {open && (
                <TextField
                    inputRef={inputRef}
                    size="small"
                    value={query}
                    placeholder="Date, description, voucher, amount"
                    onChange={(e) => onQueryChange(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Escape') onToggle();
                    }}
                    sx={{width: 260}}
                />
            )}
            {open && query.trim() !== '' && matchCount != null && (
                <Typography variant="caption" color="text.secondary" sx={{whiteSpace: 'nowrap'}}>
                    {matchCount} {matchCount === 1 ? 'match' : 'matches'}
                </Typography>
            )}
        </Stack>
    );
}
